var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{style:({'width': _vm.width}),attrs:{"type":_vm.type,"loading":_vm.loading},on:{"click":_vm.doClick}},[_vm._v(_vm._s(_vm.getText))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1959ac79","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/FwSaveButton.vue
// module id = 935
// module chunks = 0